import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";

import { ShiftBundlePill } from "./Pill";
import { formatApproximatePayInCentsAsUsd } from "./utils";

interface ShiftBundleFooterProps {
  requiredShiftCount: number;
  totalShiftCount: number;
  totalPayInMinorUnits: number | undefined;
}

export function ShiftBundleFooter(props: ShiftBundleFooterProps) {
  const { requiredShiftCount, totalShiftCount, totalPayInMinorUnits } = props;

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ paddingX: 5, paddingY: 4 }}
    >
      <ShiftBundlePill requiredShiftCount={requiredShiftCount} totalShiftCount={totalShiftCount} />
      {isDefined(totalPayInMinorUnits) && (
        <Text semibold variant="body1" sx={{ whiteSpace: "nowrap" }}>
          {requiredShiftCount !== totalShiftCount && (
            <Text inline variant="body1" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
              Up to{" "}
            </Text>
          )}
          {formatApproximatePayInCentsAsUsd(totalPayInMinorUnits)}
          {requiredShiftCount === totalShiftCount && (
            <Text inline variant="body1" sx={(theme) => ({ color: theme.palette.text.tertiary })}>
              {" "}
              total
            </Text>
          )}
        </Text>
      )}
    </Stack>
  );
}
